const ArrayIgnorePatterns = [/^fields\[.*\]$/, /^sort\[.*\]$/];

export const toCamelCase = (str) => {
  return str.replace(/([-_][a-z])/g, (group) =>
    group.toUpperCase().replace('-', '').replace('_', '')
  );
};

export const toSnakeCase = (str) => {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};

export const convertKeys = (
  obj,
  converter,
  ignorePatterns = ArrayIgnorePatterns
) => {
  if (!obj) return obj;

  if (Array.isArray(obj)) {
    return obj.map((v) => convertKeys(v, converter, ignorePatterns));
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [ignorePatterns?.some((pattern) => pattern.test(key))
          ? key
          : converter(key)]: convertKeys(obj[key], converter, ignorePatterns),
      }),
      {}
    );
  }
  return obj;
};
